import React,{Component} from 'react';
import { NavLink } from 'react-router-dom';
//import Trends from './partials/Trends';
import Footer from './partials/Footer'; 

class Company extends React.Component {

    componentWillMount () {
        
        const script = document.createElement("script");
     
        script.src = "/assets/js/menutoggle.js";
       
        script.async = true;
     
        document.body.appendChild(script);
       
      }
      
   render(){
 
    return(
        <div>
        <div class="main-banner companybg newonetop">
        <div class="container bo">
                <img src="/assets/images/top-banner-below-3-3px.svg" class="middlediv container" />
                </div>
                <div class="container">
                <img src="/assets/images/top-banner-below-3-3px.svg" class="middlediv container" />
              <header class="main-header d-flex justify-content-between">
                                           <div class="site-logo">
                                              
                                              <NavLink to="/"> <img src="assets/images/openpoint_logo.png" class="logotop" /></NavLink>
                                           </div>
                                           <div class="menu-toggle-icon">
                                              <span class="hamburger-inner"></span>
                                           </div>
                                           <div class="site-login">
                                              <div class="menu-toggle-bg"></div>
                                              <div class="site-login-inner">
                                                 <div class="site-logo menu-with-logo">
                                                     <NavLink to="/"><img src="assets/images/openpoint_logo.png" class="logotop" /></NavLink>
                                                 </div>
                                                  
                                                 <a href="/quote" className="mr-4 top-link mobi" id="get-start">Get a Quote</a>
                                                  <NavLink to="/signals" className="mr-4 top-link mobi" >Signals</NavLink>
                                                 
                                                <NavLink to="/" className="mr-4 top-link desk">Home</NavLink>
                                                 <NavLink to="/signals" className="mr-4 top-link desk">Signals</NavLink>
                                                                                         <NavLink to="/careers" className="mr-4 top-link">Careers</NavLink>
                                                                                         
                                                                                         <NavLink to="/company" className="mr-4 top-link">Company</NavLink> 
                                                                                         {/* <NavLink to="/" className="mr-4 top-link desk">Login</NavLink> */}
                                                 <NavLink to="/quote" className="btn btn-lg btn-flat btn-outline ml-3 desk get33">Get a Quote</NavLink>
                                              </div>
                                           </div>
                                        </header>
                
            <div class="row justify-content-center">
               <div class="col-md-9">
               <div class="banner-content text-center comp">
                     <h1 class="banner-title">About openpoint</h1>
                     <div class="banner-description">
                        <p><span class="freet" >openpoint provides real-time insights about your audience</span></p>
                     </div>
                    
                     </div>
               <div>
                   <p class="ptext">
                   Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut 
                   labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco 
                   laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in 
                   voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat 
                   non proident, 
                   sunt in culpa qui officia deserunt mollit anim id est laborum
                   </p>
               </div>
               
               </div> </div>  </div> </div> 

               
                               <section class="call-to-action container newprovider">
                                <div class="innerprovider">
                                    <h2 class="freeh2"> Provider</h2>
                                    <ul>
                                        <li>
                                            <a href='#'>Provider1</a>
                                        </li>
                                        <li>
                                            <a href='#'>Provider2</a>
                                        </li>
                                        <li>
                                            <a href='#'>Provider2</a>
                                        </li>
                                    </ul>

                                </div>

                               </section>
                <section class="g-grid-container g-open-positions">
    <header class="header">
        <h3 class="heading g-type-display-2">Lorem ipsum dolor sit amet, consectetur adipiscing elit</h3>
        <p class="subheading g-type-body-large">Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
    </header>
    
</section>

               <section id="top" data-section-id="mnutwt" data-section="main" class="upflow-12 pt-2 pb-6 custom text-center bg-center headlines-dark">
    <div class="container" data-section-container-main="mnutwt">
        <div data-section-row-main="mnutwt" class="row flex-row justify-content-center align-items-center">
          
            <div class="col col-cards col-12 py-2 py-md-4">
                <div class="col-inside col-inside-cards text-center list-">
                    <div class="row flex-row row-cards justify-content-center justify-content-md-around">
                        <div class="col col-card col-12 col-sm-10 col-md-6 col-lg-4">
                            <div class="col-inside col-inside-card h-100 py-2">
                                <a class="wrapper-link card-wrapper-link" href="javascript:void(0)" >
                                    <div class="card h-100 d-flex flex-column justify-content-md-between dropshadow no-border top-border-6px text-left hl-sm card-icon-image-left border-dark">
                                        <div class="wrapper-card-content d-flex justify-content-md-between h-100 flex-row">
                                            <figure class="figure figure-cards w-100">
                                                <img
                                                    class="lazy image img-fluid figure-img icon-image rounded-circle card-img-top loaded"
                                                    alt="1"
                                                    src="assets/images/fitness_insights.jpg"
                                                />
                                            </figure>

                                            <div class="card-body d-flex flex-column h-100 justify-content-between">
                                                <div class="d-flex flex-column h-100 justify-content-md-start">
                                                    <h5 class="headline headline-col headline-col-cards">
                                                        <span class="superheadline">Live Event</span>

                                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit
                                                    </h5>

                                                    <div class="">
                                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>
                                                    </div>
                                                </div>

                                                <div class="buttons buttons-cards">
                                                    <div class="link link-primary icon-after wrapped-link">
                                                        Register Now
                                                        <svg
                                                            class="svg-inline--fa fa-arrow-right fa-w-14"
                                                            aria-hidden="true"
                                                            focusable="false"
                                                            data-prefix="fal"
                                                            data-icon="arrow-right"
                                                            role="img"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 448 512"
                                                            data-fa-i2svg=""
                                                        >
                                                            <path
                                                                fill="currentColor"
                                                                d="M216.464 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887L209.393 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L233.434 36.465c-4.686-4.687-12.284-4.687-16.97 0z"
                                                            ></path>
                                                        </svg>
                                                      
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col col-card col-12 col-sm-10 col-md-6 col-lg-4">
                            <div class="col-inside col-inside-card h-100 py-2">
                                <a class="wrapper-link card-wrapper-link" href="javascript:void(0)" >
                                    <div class="card h-100 d-flex flex-column justify-content-md-between dropshadow no-border top-border-6px text-left hl-sm card-icon-image-left border-dark">
                                        <div class="wrapper-card-content d-flex justify-content-md-between h-100 flex-row">
                                            <figure class="figure figure-cards w-100">
                                                <img
                                                    class="lazy image img-fluid figure-img icon-image rounded-circle card-img-top loaded"
                                                    alt="1"
                                                    src="assets/images/fitness_insights.jpg"
                                                />
                                            </figure>

                                            <div class="card-body d-flex flex-column h-100 justify-content-between">
                                                <div class="d-flex flex-column h-100 justify-content-md-start">
                                                    <h5 class="headline headline-col headline-col-cards">
                                                        <span class="superheadline">Live Event</span>

                                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit
                                                    </h5>

                                                    <div class="">
                                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>
                                                    </div>
                                                </div>

                                                <div class="buttons buttons-cards">
                                                    <div class="link link-primary icon-after wrapped-link">
                                                        Register Now
                                                        <svg
                                                            class="svg-inline--fa fa-arrow-right fa-w-14"
                                                            aria-hidden="true"
                                                            focusable="false"
                                                            data-prefix="fal"
                                                            data-icon="arrow-right"
                                                            role="img"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 448 512"
                                                            data-fa-i2svg=""
                                                        >
                                                            <path
                                                                fill="currentColor"
                                                                d="M216.464 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887L209.393 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L233.434 36.465c-4.686-4.687-12.284-4.687-16.97 0z"
                                                            ></path>
                                                        </svg>
                                                      
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>

                        <div class="col col-card col-12 col-sm-10 col-md-6 col-lg-4">
                            <div class="col-inside col-inside-card h-100 py-2">
                                <a class="wrapper-link card-wrapper-link" href="javascript:void(0)" data-g-action="" data-g-label="">
                                    <div class="card h-100 d-flex flex-column justify-content-md-between dropshadow no-border top-border-6px text-left hl-sm card-icon-image-left border-dark">
                                        <div class="wrapper-card-content d-flex justify-content-md-between h-100 flex-row">
                                            <figure class="figure figure-cards w-100">
                                                <img
                                                    class="lazy image img-fluid figure-img icon-image rounded-circle card-img-top loaded"
                                                    alt="1"
                                                    src="assets/images/fitness_insights.jpg"
                                                />
                                            </figure>

                                            <div class="card-body d-flex flex-column h-100 justify-content-between">
                                                <div class="d-flex flex-column h-100 justify-content-md-start">
                                                    <h5 class="headline headline-col headline-col-cards">
                                                        <span class="superheadline">Live Event</span>

                                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit
                                                    </h5>

                                                    <div class="">
                                                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>
                                                    </div>
                                                </div>

                                                <div class="buttons buttons-cards">
                                                    <div class="link link-primary icon-after wrapped-link">
                                                        Register Now
                                                        <svg
                                                            class="svg-inline--fa fa-arrow-right fa-w-14"
                                                            aria-hidden="true"
                                                            focusable="false"
                                                            data-prefix="fal"
                                                            data-icon="arrow-right"
                                                            role="img"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            viewBox="0 0 448 512"
                                                            data-fa-i2svg=""
                                                        >
                                                            <path
                                                                fill="currentColor"
                                                                d="M216.464 36.465l-7.071 7.07c-4.686 4.686-4.686 12.284 0 16.971L387.887 239H12c-6.627 0-12 5.373-12 12v10c0 6.627 5.373 12 12 12h375.887L209.393 451.494c-4.686 4.686-4.686 12.284 0 16.971l7.071 7.07c4.686 4.686 12.284 4.686 16.97 0l211.051-211.05c4.686-4.686 4.686-12.284 0-16.971L233.434 36.465c-4.686-4.687-12.284-4.687-16.97 0z"
                                                            ></path>
                                                        </svg>
                                                      
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>

                      
                      </div>
                </div>
            </div>
           
        </div>
    </div>
</section>

<section id=""  class="py-0 hl-sm bg-white-to-lighter text-left bg-cover bg-top bottomseccomp pk">
    <div class="container" data-section-container-main="zqdmez">
        <div data-section-row-main="zqdmez" class="row flex-row justify-content-center justify-content-md-around align-items-center">
            <div class="col col-image col-image col-12 col-md-5 py-2 py-md-4">
                <div class="col-inside col-inside-image col-inside-image w-100">
                    <figure class="figure figure-image w-100">
                        <img
                            class="lazy image img-fluid figure-img loaded"
                            alt="1"
                            src="assets/images/know-grow-audience-min-1024x1024-1-500x500.png"
                            data-src="assets/images/know-grow-audience-min-1024x1024-1-500x500.png"
                            data-first-load="assets/images/know-grow-audience-min-1024x1024-1-500x500.png"
                            data-srcset="assets/images/know-grow-audience-min-1024x1024-1-500x500.png 500w, assets/images/know-grow-audience-min-1024x1024-1-300x300.png 300w, assets/images/know-grow-audience-min-1024x1024-1.png 1024w, assets/images/know-grow-audience-min-1024x1024-1-150x150.png 150w, assets/images/know-grow-audience-min-1024x1024-1-768x768.png 768w, assets/images/know-grow-audience-min-1024x1024-1-800x800.png 800w"
                            sizes="(max-width: 500px) 100vw, 500px"
                            srcset="
                                assets/images/know-grow-audience-min-1024x1024-1-500x500.png  500w,
                                assets/images/know-grow-audience-min-1024x1024-1-300x300.png  300w,
                                assets/images/know-grow-audience-min-1024x1024-1.png         1024w,
                                assets/images/know-grow-audience-min-1024x1024-1-150x150.png  150w,
                                assets/images/know-grow-audience-min-1024x1024-1-768x768.png  768w,
                                assets/images/know-grow-audience-min-1024x1024-1-800x800.png  800w
                            "
                            data-was-processed="true"
                        />
                    </figure>
                </div>
            </div>

            <div class="col col-copy col-12 col-md-6 col-lg-5 py-2 py-md-4">
                <div class="col-inside col-inside-copy w-100">
                    <h2 class="headline headline-col headline-col-copy">
                        Know and grow your&nbsp;audience
                    </h2>

                    <div class="d-flex flex-column flex-column-wrap">
                        <div class="text text-col text-col-copy order-first">
                            <p class="text-lg">The openpoint Platform empowers brands, agencies, and publishers to know and grow their audiences on the open&nbsp;internet.</p>
                        </div>

                        <div class="buttons buttons-copy">
                           
                             <NavLink to="/" className="btn btn-outline-primary icon icon-after button-custom">Learn More
                             <svg focusable="false" class="ibm-duo-u--link-icon--arrow-right" preserveAspectRatio="xMidYMid meet" xmlns="http://www.w3.org/2000/svg" fill="currentColor" aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" slot="icon"><path d="M11.8 2.8L10.8 3.8 16.2 9.3 1 9.3 1 10.7 16.2 10.7 10.8 16.2 11.8 17.2 19 10z"></path></svg>
                             </NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

                
                 <div class="g-call-to-action variant-compact theme-light">
    <div class="g-grid-container">
        <h2 data-testid="heading" class="g-type-display-2">What is Lorem Ipsum?</h2>
        <div class="content-and-links">
            <p data-testid="content" class="g-type-body-large">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
            <div data-testid="links" class="links">
                <a class="g-btn size-medium variant-primary background-light" data-ga-button="contact-sales" href="#"><span class="text g-type-buttons-and-standalone-links">Contact Sales</span></a>
                <a class="g-btn size-medium variant-secondary background-light" data-ga-button="request-demo" href="#"><span class="text g-type-buttons-and-standalone-links">Request Demo</span></a>
            </div>
        </div>
    </div>
</div>
              <Footer />
<div class="row -center hero-row popupde">
    <div class="close2">
        <a class="close-atag" href="javascript:void(0);">
            <img src="assets/images/xlose.png" />
        </a>
    </div>
<img class="feature-callout__img" src="https://luna1.co/005100.png" alt="Image of team" width="112" />
            <div class="signupForm-homepage-center col-xsmall-12 col-small-8 col-small-offset-2 col-medium-10 col-medium-offset-1 col-large-8 col-large-offset-2 col-xlarge-6 col-xlarge-offset-3">
                <h4 class="heading -spacing-2 -h3">Sign up</h4>
                <p class="subheading -spacing-1 hero-legal-copy">
                    By signing up, I agree to the Asana <a href="/terms#privacy-policy" class="css-1kfjk3x-Link">Privacy Policy</a> and <a href="/terms#terms-of-service" class="css-1kfjk3x-Link">Terms of Service</a>.
                </p>
                <form action="get-started/verify" method="get" novalidate="" class="signupForm hidden-logged-in signupForm-homepage-center" __bizdiag="1239199729" __biza="WJ__">
                    <div class="signupForm-container">
                        <div class="signupForm-row">
                        <div class="form-group">
                                
                                <input type="email" name="e" required  class="form-control" placeholder="name@company.com" id="work-email" />
                            </div>

                            <div class="submit-btn">
                                <button id="go-to-nextStep"  onClick={this.toggleBox} class="btn btn-lg btn-flat btn-block btn-primary">Next</button>
                            </div>
                        </div>
                    </div>
                </form>
                
            </div>
        </div>
 </div>
    );
}
}

export default Company;